import { useMutation } from '@tanstack/react-query';

import { notifyMeta } from '@/lib/notify';
import { authService } from '@/services/auth';
import { errorUtils } from '@/services/errors';

const useRequestPasswordReset = () => {
  return useMutation<void, Error, string>({
    meta: notifyMeta('authPasswordResetRequest'),
    mutationFn: async (email) => {
      errorUtils.unwrap(await authService.requestPasswordReset(email));
    },
  });
};

export {
  useRequestPasswordReset,
};
